export enum FileAttachmentError {
    FILETYPE,
    FILESIZE
}
